import { getLocalizedValue } from '../../constants/Languages';
import { getApiErrorCode } from '../../utils/apiErrorCode';

const CONSENT_FORM_API_ERROR_CODES = [
  'ConsentFormNotFound',
  'InvalidConsentFormData',
  'ConsentFormArchived',
  'ConsentFormRequired',
  'ConsentFormVersionNotCurrent',
  'ConsentFormHasNoVersion',
  'ConsentFormNotReadToEnd',
  'InvalidFileType',
  'FileTooLarge',
  'PlanUpgradeRequired',
];

export const getConsentFormName = (name, language, t) => (
  getLocalizedValue(name, language, undefined, t('consentForms.unnamed'))
);

/** The i18n key describing a failed consent form request, or the fallback key. */
export const getConsentFormErrorKey = (error, fallbackKey) => {
  const code = getApiErrorCode(error);
  return CONSENT_FORM_API_ERROR_CODES.includes(code) ? `consentForms.apiErrors.${code}` : fallbackKey;
};

export const formatFileSize = (bytes) => {
  const value = Number(bytes) || 0;
  if (value >= 1024 * 1024) {
    return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  }

  return `${Math.max(1, Math.round(value / 1024))} KB`;
};

/** The distinct consent forms asked for by a set of services, for owner-facing summaries. */
export const getConsentFormsForServices = (serviceIds, services, consentForms) => {
  const formsById = new Map((consentForms || []).map((form) => [form.id, form]));
  const servicesById = new Map((services || []).map((service) => [service.id, service]));
  const seen = new Set();

  return (serviceIds || []).reduce((result, serviceId) => {
    const formId = servicesById.get(serviceId)?.consentFormId;
    const form = formId ? formsById.get(formId) : null;
    if (form && !seen.has(form.id) && form.status === 'Active' && form.currentVersion) {
      seen.add(form.id);
      result.push(form);
    }
    return result;
  }, []);
};
